<template>
    <div class="title-block">
        <div class="title-block__left">
            <div class="title-block__title">Группы устройств</div>
            <a class="title-block__btn btn-add btn-primary btn" :href="route_create_page">Добавить</a>
        </div>
    </div>
    <div class="filter-table">
        <div class="filter-table__input-wrap search-control">
            <input
                @keyup.delete="onDeleteSearch()"
                @keyup.enter="onSearch()"
                type="text"
                v-model="search"
                class="search-control__input form-control"
                placeholder="Поиск"
            >
            <button @click="onSearch()" class="search-control__input-btn reset-btn">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M2.5 8.333a5.834 5.834 0 1011.667 0 5.834 5.834 0 00-11.667 0zM17.5 17.5l-5-5"
                        stroke="currentColor" stroke-width="1.667" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
            </button>
        </div>

        <v-select style="margin-right: auto;"
            label="Бренд"
            v-model="brand"
            :items="brands"
            @update:modelValue="onChangeBrand"
            @update:menu="$removeFocus"
            @click:clear="$removeFocus"
            @click:control="$removeFocus"
            item-title="name"
            item-value="id"
            variant="outlined"
            color="primary"
            clearable
            density="compact">
            <template #no-data>
                <span>Данные не найдены</span>
            </template>
        </v-select>
    </div>

    <div class="table-responsive">
        <table class="table">
            <thead>
                <tr>
                    <th v-for="elem in thead">{{ elem }}</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="row in tbody">
                    <td>{{ row.tbody.name }}</td>
                    <td>{{ row.tbody.device_type }}</td>
                    <td>{{ row.tbody.brand_name }}</td>
                    <td>
                        <div class="table-icon-item table-icon-item_sm me-4">
                            <img class="table-icon-item__icon" src="/images/icon_building.svg" alt="">
                            <span>{{ row.tbody.quantity_locations }}</span>
                        </div>
                        <div class="table-icon-item table-icon-item_sm">
                            <img class="table-icon-item__icon" src="/images/icon_count-device.svg" alt="">
                            <span>{{ row.tbody.quantity_devices }}</span>
                        </div>
                    </td>
                    <td>{{ row.tbody.created_at }}</td>
                    <td>
                        <div class="table-actions">
                            <a :href="route_update_page + row.id"  class="table-action table-action_edit" title="Редактировать"></a>
                            <button @click="deleteGroup(row.id)" class="table-action table-action_delete" title="Удалить"></button>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
    <pagination-element :count="count" :current_page="page" @pageChange="pageChange"></pagination-element>
</template>
<script>

import { withPopper } from '../../../utilites.js';
import PaginationElement from '../../../elements/PaginationElement.vue'
import Group from '../../../models/Group'
export default {
    name: "GroupComponent",
    components: { PaginationElement },
    props: {
        route_create_page: String,
        route_list: String,
        route_delete: String,
        route_update_page: String,
        route_brands_list: String,
        current_page: {
            type: Number,
            default: 1
        }
    },
    data: function () {
        return {
            brand: null,
            selected_brand : null,
            brands: [],
            group: new Group({
                route_list: this.route_list,
                route_delete: this.route_delete
            }),
            search: '',
            thead: [
                'Название группы',
                'Тип ус-ва',
                'Бренд',
                'Количество аптек / устройств',
                'Дата создания',
                'Действия'
            ],
            tbody: [],
            count: 1,
            limit: 30,
            page: 1,
            nameGroup: '',
        };
    },
    methods: {
        updateGroup: function (params) {
            window.location.href = this.route_update_page + params.id;
        },
        deleteGroup: function (group_id) {
            let conf = confirm('Вы уверены что хотите удалить запись ?');
            if(!conf) {
                return;
            }
            if (conf) {
                this.group.delete(group_id).then(this.loadTable);
            }
        },
        loadTable: async function () {
            let response = await this.group.loadTable(this.page, this.limit, this.search, this.selected_brand);
            this.tbody = response.tbody;
            this.count = response.pages;
        },
        onSearch: async function() {
            this.page = 1;
            await this.loadTable()
        },
        onDeleteSearch: async function () {
            if (this.search.trim() == '') {
                this.page = 1;
                await this.loadTable()
            }
        },
        pageChange: function (newPage) {
            this.page = newPage;
            this.loadTable();
        },
        getBrands: async function () {
            let data = await axios.get(this.route_brands_list);
            this.brands = data.data.items;
        },
        onChangeBrand: async function (brand_id) {
            this.selected_brand = brand_id;
            await this.loadTable();
        },
        withPopper,
    },

    mounted() {
        this.loadTable();
        this.getBrands();
    }
};
</script>
